var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_32812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99749 11.7147C10.4965 11.7147 11.7118 10.4995 11.7118 9.00042C11.7118 7.50136 10.4965 6.28613 8.99749 6.28613C7.49843 6.28613 6.2832 7.50136 6.2832 9.00042C6.2832 10.4995 7.49843 11.7147 8.99749 11.7147Z",
    fill: "#757185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3905 0.857422H5.60479C2.98618 0.857422 0.855469 2.98882 0.855469 5.6081V12.3938C0.855469 15.0124 2.98686 17.1431 5.60615 17.1431H12.3919C15.0105 17.1431 17.1412 15.0117 17.1412 12.3925V5.60674C17.1412 2.98814 15.0098 0.857422 12.3905 0.857422ZM8.99833 13.0717C6.75293 13.0717 4.9269 11.2457 4.9269 9.00028C4.9269 6.75489 6.75293 4.92885 8.99833 4.92885C11.2437 4.92885 13.0698 6.75489 13.0698 9.00028C13.0698 11.2457 11.2437 13.0717 8.99833 13.0717ZM13.7483 4.92885C13.3738 4.92885 13.0698 4.62485 13.0698 4.25028C13.0698 3.87571 13.3738 3.57171 13.7483 3.57171C14.1229 3.57171 14.4269 3.87571 14.4269 4.25028C14.4269 4.62485 14.1229 4.92885 13.7483 4.92885Z",
    fill: "#757185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_32812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(0.427734 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dd7960406d87098b628fd0fcb8cb50f1.svg";
export { ForwardRef as ReactComponent };